<template>
  <v-card
    elevation="3"
    rounded="lg"
  >
    <v-toolbar
      flat
      dense
      color="color_green"
      dark
    >
      <v-toolbar-title class="text-subtitle-2">
        Daily Calls – {{ year }}
      </v-toolbar-title>
      <v-spacer />
      <span
        v-if="username"
        class="text-caption"
      >{{ username }}</span>
    </v-toolbar>

    <v-card-text>
      <div
        v-if="loading"
        class="d-flex justify-center pa-6"
      >
        <v-progress-circular
          indeterminate
          color="color_green"
        />
      </div>
      <div
        v-else-if="!items.length"
        class="text-center grey--text pa-6"
      >
        No data
      </div>
      <div
        v-else
        class="sparkline-wrapper"
      >
        <svg
          :viewBox="`0 0 ${svgW} ${svgH}`"
          preserveAspectRatio="none"
          class="sparkline-svg"
        >
          <polyline
            :points="polylinePoints"
            fill="none"
            stroke="var(--v-color_green-base, #2e7d32)"
            stroke-width="2"
            stroke-linejoin="round"
            stroke-linecap="round"
          />
          <polygon
            :points="areaPoints"
            fill="var(--v-color_green-base, #2e7d32)"
            fill-opacity="0.15"
          />
        </svg>
        <div class="sparkline-labels">
          <span>{{ items[0] && items[0].day }}</span>
          <span>{{ items[Math.floor(items.length / 2)] && items[Math.floor(items.length / 2)].day }}</span>
          <span>{{ items[items.length - 1] && items[items.length - 1].day }}</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
const SVG_W = 600;
const SVG_H = 100;
const PAD = 8;

export default {
  name: 'DailySparkline',
  props: {
    items: { type: Array, default: () => [] },
    year: { type: Number, required: true },
    username: { type: String, default: null },
    loading: { type: Boolean, default: false }
  },
  computed: {
    svgW() {
      return SVG_W;
    },
    svgH() {
      return SVG_H;
    },
    maxVal() {
      return this.items.length
        ? Math.max(...this.items.map(i => i.call_count), 1)
        : 1;
    },
    coords() {
      const n = this.items.length;

      if (!n) {
        return [];
      }

      return this.items.map((item, i) => {
        const x = PAD + ((SVG_W - 2 * PAD) / (n - 1 || 1)) * i;
        const y = (SVG_H - PAD) - ((item.call_count / this.maxVal) * (SVG_H - 2 * PAD));

        return { x, y };
      });
    },
    polylinePoints() {
      return this.coords.map(c => `${c.x},${c.y}`).join(' ');
    },
    areaPoints() {
      if (!this.coords.length) {
        return '';
      }

      const first = this.coords[0];
      const last = this.coords[this.coords.length - 1];

      return [
        `${first.x},${SVG_H - PAD}`,
        ...this.coords.map(c => `${c.x},${c.y}`),
        `${last.x},${SVG_H - PAD}`
      ].join(' ');
    }
  }
};
</script>

<style scoped>
.sparkline-wrapper { padding: 4px 0; }
.sparkline-svg {
  width: 100%;
  height: 100px;
  display: block;
}
.sparkline-labels {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: rgba(0,0,0,0.4);
  margin-top: 4px;
}
</style>
